import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { isMobile, isTablet } from 'react-device-detect';
import { IDeliveryBatch } from '../../../interfaces/delivery-company/tasks';
import { timestampedMessage } from '../../common/multi-package-scanner/multi-package-scanner';
import { generateQRCode } from '../../common/task-barcode-printer/task-barcode-printer';
import QRCodeBox from '../../common/qrcode-box/qrcode-box';
import ItemsCount from '../../common/labels-input/items-count/items-count';
import DriverDeliveryBatchPage from './driver-delivery-batch-page';
import {
  deliveryBatchToQRcodeID,
  get_district_set,
} from '../../../utils/delivery-tasks';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import { DriverWithIcon } from '../../common/styles/driver-with-icon';

interface DeliveryBatchDialogProps {
  task: IDeliveryBatch;
  onClose: () => void;
  setSnackBarResult: (t?: timestampedMessage) => void;
  onSuccess?: () => void;
}

function DeliveryBatchDialog({
  task,
  onClose,
  setSnackBarResult,
  onSuccess,
}: DeliveryBatchDialogProps) {
  return (
    <CustomDialog
      open={true}
      onClose={onClose}
      fullWidth
      fullScreen={(isMobile && !isTablet)}
      maxWidth="xl"
    >
      <DialogContent>
        <Typography variant="h3" textAlign="center">
          Delivery Batch #{task.id}
        </Typography>
        <QRCodeBox value={deliveryBatchToQRcodeID(task)} centered size={100} />
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            justifyItems: 'center',
            alignItems: 'center',
          }}
        >
          <ItemsCount label={`# items: ${task?.package_count}`} />
          <div>
            <DriverWithIcon driver={task.driver} />
          </div>
          <div>
            <b>Districts:</b> {Array.from(get_district_set(task)).join(', ')}
          </div>
        </div>
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
          }}
        >
          <IconButton onClick={onClose}>
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
        </div>
        <DriverDeliveryBatchPage
          deliverytaskId={task.id}
          onClose={onClose}
          setSnackBarResult={(t?: timestampedMessage) => setSnackBarResult(t)}
          onSuccess={onSuccess}
        />
      </DialogContent>
    </CustomDialog>
  );
}

export default DeliveryBatchDialog;
